import { render, staticRenderFns } from "./AddPosition.vue?vue&type=template&id=94627d56&"
import script from "./AddPosition.vue?vue&type=script&lang=js&"
export * from "./AddPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports